import React from 'react';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import FacetPlanComponent from './Main';

const FacetPlan = () => {
  const { householdResource } = useSimpleHousehold();

  return pickFunction(householdResource, {
    [fr.relationships.default.name]: () => {
      return null;
    },
    [fr.relationships.facetPlan.name]: (props) => {
      return (
        <FacetPlanComponent {...props} />
      );
    },
  });
};

export default FacetPlan;
